<template>
  <vue-clip
    ref="vc"
    :options="options"
    :on-added-file="addedFile"
    :on-complete="completeFile"
    :on-sending="onSending"
    :on-removed-file="removedFile"
    class="custom-uploader custom-uploader--multi"
  >
    <template #clip-uploader-body>
      <template v-if="files.length">
        <VueGallery :images="images" :index="index" @close="index = null" />
        <div class="custom-uploader__previews">
          <div
            class="custom-uploader__preview"
            v-for="(image, imageIndex) in files"
            :key="imageIndex"
          >
            <button
              type="button"
              class="custom-uploader__preview-delete"
              @click="removedFile(image)"
            />
            <app-spinner v-if="!image.file" />
            <img v-else :src="image.file" @click="index = imageIndex" alt="Preview">
          </div>
        </div>
      </template>

<!--      <div v-for="file in files" :key="file.id" class="custom-uploader__file">-->
<!--        <div class="custom-uploader__body">-->
<!--          <div class="custom-uploader__part">-->
<!--            <a-->
<!--              :href="file.file || file.customAttributes.link"-->
<!--              target="_blank"-->
<!--              class="custom-uploader__filename"-->
<!--            >-->
<!--              <img src="@/assets/img/attach-file-icon.svg" alt="">-->
<!--              {{ file.file_name || file.name }}-->
<!--            </a>-->
<!--          </div>-->
<!--          <div class="custom-uploader__part">-->
<!--            <div-->
<!--              v-if="file.status !== 'error' && file.status !== 'success' && file.progress"-->
<!--              class="custom-uploader__progress"-->
<!--            >-->
<!--              {{ Math.round(file.progress) }}%-->
<!--            </div>-->
<!--            <button-->
<!--              type="button"-->
<!--              class="custom-uploader__delete"-->
<!--              @click="removedFile"-->
<!--            >-->
<!--              <img src="@/assets/img/delete-uploader-icon.svg" alt="">-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div-->
<!--          class="custom-uploader__line"-->
<!--          v-if="file.status !== 'error' && file.status !== 'success' && file.progress"-->
<!--        >-->
<!--          <span-->
<!--            class="custom-uploader__indicator"-->
<!--            :style="{ width: file.progress + '%' }"-->
<!--          ></span>-->
<!--        </div>-->
<!--      </div>-->
      <div v-if="message" class="custom-uploader__error">{{ message }}</div>
    </template>
    <template #clip-uploader-action="params">
      <div
        class="custom-uploader__action"
        :class="{ 'uploader__action--dragging': params.dragging }"
      >
        <div class="custom-uploader__message dz-message">
          <div
            class="custom-uploader__drop"
            v-show="files.length < $props.limit"
          >
            <div class="custom-uploader__icon">
              <img src="@/assets/img/file/clip.svg" alt="Загрузить файлы">
              <span>Attach files</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </vue-clip>
</template>

<script>
import VueGallery from 'vue-gallery'
import { getAccessToken } from 'axios-jwt'

export default {
  name: 'AppMultiUploader',
  components: { VueGallery },
  props: {
    files_prop: Array,
    extensions: {
      type: Array,
      default: () => ['image/*'],
    },
    formDataFormats: {
      type: String,
      default: 'JPEG,BMP,PNG,TIFF',
    },
    url: {
      type: String,
      default: `${process.env.VUE_APP_API_URL}files/`,
    },
    limit: {
      type: Number,
      default: 5,
    },
  },
  model: {
    prop: 'files_prop',
    event: 'onAddedFile',
  },
  data() {
    return {
      index: null,
      options: {
        url: this.$props.url,
        acceptedFiles: {
          extensions: this.$props.extensions,
          message: 'Wrong file format',
        },
        maxFilesize: {
          limit: 15,
          message: 'File size exceeds allowed',
        },
        uploadMultiple: false,
        parallelUploads: this.limit,
      },
      message: '',
      progress: 0,
      files: [],
    }
  },
  computed: {
    images() {
      return this.files.map(({file}) => file)
    }
  },
  methods: {
    addedFile(file) {
      this.files.push(file)
    },
    onSending(_, xhr, formData) {
      xhr.setRequestHeader('Authorization', `Bearer ${getAccessToken()}`)
      formData.append('size', 15)
      formData.append('formats', this.formDataFormats)
    },
    completeFile(file, status, xhr) {
      if (file.status === 'error') {
        this.message = file.errorMessage
        this.removedFile(file)
        return false
      }
      const response = JSON.parse(xhr.responseText)
      file.addAttribute('link', response.file)
      this.files.push(response)
      this.files = this.files.filter(item => !item.size)
      this.$emit('onAddedFile', this.files)
      this.message = ''
    },
    removedFile(file) {
      this.$refs.vc.files.splice(this.$refs.vc.files.indexOf(file), 1)
      this.files.splice(this.files.indexOf(file), 1)
      this.$emit('onAddedFile', this.files)
    },
  },
}
</script>

<style lang="sass" scoped>
.custom-uploader__previews
  display: grid
  grid-template-columns: 1fr 1fr
  gap: 10px
  margin-top: 20px

.custom-uploader__preview
  position: relative
  aspect-ratio: 1
  overflow: hidden

  img
    width: 100%
    height: 100%
    object-fit: cover

.custom-uploader__preview-delete
  position: absolute
  top: 5px
  right: 5px
  width: 30px
  height: 30px
  background-image: url('~@/assets/img/card-remove.svg')
  background-size: cover

.custom-uploader--multi
  display: flex
  flex-direction: column

  .custom-uploader__message
    display: flex

.custom-uploader__message
  display: inline-flex
  align-items: center
  cursor: pointer

  img
    margin-right: 15px

  span
    color: $color-theme
    font-size: 18px

.custom-uploader__body
  display: flex
  justify-content: space-between

.custom-uploader__line
  width: 100%
  height: 5px
  margin-top: 5px
  background-color: rgba(56, 123, 191, 0.2)
  border-radius: 50px

.custom-uploader__indicator
  display: block
  width: 0
  height: 100%
  background-color: $color-theme
  border-radius: 50px
  transition: width 0.5s

.custom-uploader__part
  display: flex
  align-items: center

  &:last-child
    flex-shrink: 0

.custom-uploader__img
  flex-shrink: 0
  width: 120px
  height: 120px
  margin-right: 15px

  img
    width: 100%
    height: 100%
    object-fit: cover

.custom-uploader__file
  margin-top: 15px

.custom-uploader__filename
  display: flex
  align-items: center
  gap: 10px
  color: #5f5f5f
  font-size: 14px
  text-decoration: none
  word-break: break-word
  transition: color 0.3s

.custom-uploader__progress
  color: $color-theme
  font-size: 14px

.custom-uploader__error
  margin-top: 5px
  font-size: 13px
  color: $color-error

.custom-uploader__delete
  display: flex
  align-items: center
  margin-left: 15px
  color: #ea5467
  font-size: 16px
  line-height: 0
  transition: color 0.3s

  img
    width: 10px
    height: 10px

.custom-uploader__drop
  display: flex
  align-items: center
  flex-direction: column
  width: 100%
  padding: 20px
  border: 1px dashed $color-theme
  border-radius: 5px
  text-align: center
  transition: border-color 0.3s, background-color 0.3s

  p
    margin-bottom: 5px
    font-size: 15px
    color: $color-text-base

    span
      color: $color-theme
      font-size: 15px

  small
    color: #9b9b9b
    font-size: 14px

.custom-uploader__extensions
  margin-top: 5px
  color: #9b9b9b
  font-size: 13px

  &+.custom-uploader__file
    margin-top: 20px

.custom-uploader__icon
  display: flex
  align-items: center
  margin-bottom: 5px

  span
    font-size: 16px
</style>
